import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PageHeader from '../shell/PageHeader';
import { useBreadcrumb } from '../../contexts/BreadcrumbContext';
import StockLevelsTable from '../inventory/StockLevelsTable';

const SprayStockLevelsPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useBreadcrumb([
    { label: 'Citrus Synch', to: '/' },
    { label: t('spray.title'), to: '/protection' },
    { label: t('spray.stockLevels.title') },
  ]);

  return (
    <div data-testid="spray-stock-levels-page">
      <PageHeader
        title={t('spray.stockLevels.title')}
        meta={t('spray.stockLevels.meta')}
        actions={
          <button
            type="button"
            className="pat-btn pat-btn--primary"
            onClick={() =>
              navigate('/consumables/procurement/new?consumableType=chemical&from=spray-inventory')
            }
          >
            <i className="bi bi-plus-lg" aria-hidden="true" />{' '}
            {t('spray.pageHeader.actions.addStock', { defaultValue: 'Add stock' })}
          </button>
        }
      />
      <StockLevelsTable scope="chemical" />
    </div>
  );
};

export default SprayStockLevelsPage;
